import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/src/jquery";
import "bootstrap/dist/js/bootstrap.min.js";
import "ant-design-vue/dist/antd.css";
import axios from "axios";
import VueProgressBar from "vue-progressbar";
import VueToastr from "vue-toastr";
import Flutterwave from "flutterwave-vue-v3";
import Swal from 'sweetalert2';
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

// import moment from 'moment'

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faVuejs,
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube,
  faGithub
} from "@fortawesome/free-brands-svg-icons";
import {
  faSpinner,
  faAlignLeft,
  faBell,
  faClock,
  faLightbulb,
  faWifi,
  faBriefcase,
  faTag,
  faGavel,
  faMapMarkerAlt,
  faPen,
  faCommentAlt,
  faCircle,
  faEnvelope,
  faPhone,
  faCopyright,
  faTrash,
  faMicrophone,
  faVideo,
  faPaperclip,
  faEllipsisV,
  faBookmark,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faStepForward,
  faLock
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faBookmark as farBookmark } from "@fortawesome/free-regular-svg-icons";
library.add(
  faVuejs,
  faFacebookF,
  faTwitter,
  faLinkedinIn,
  faInstagram,
  faYoutube,
  faGithub,
  faSpinner,
  faAlignLeft,
  faBell,
  faClock,
  faLightbulb,
  faWifi,
  faBriefcase,
  faTag,
  faGavel,
  faMapMarkerAlt,
  faPen,
  faCommentAlt,
  faCircle,
  faEnvelope,
  faPhone,
  faCopyright,
  faTrash,
  faMicrophone,
  faVideo,
  faPaperclip,
  faEllipsisV,
  faBookmark,
  farBookmark,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faStepForward,
  faLock
);

const options = {
  color: "#2049ba",
  failedColor: "#874b4b",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300
  },
  autoRevert: true,
  location: "top",
  inverse: false
};

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.prototype.$http = axios;
Vue.prototype.$swal = Swal;
Vue.prototype.$toast = Toast;
Vue.use(Antd);
Vue.use(VueProgressBar, options);
Vue.use(VueToastr);
Vue.use(Flutterwave, {
  publicKey: "FLWPUBK_TEST-0e1410a12ad22ae8727645b63509065e-X"
});

Vue.config.productionTip = false;

axios.defaults.withCredentials = true;
const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
